import React, { useState, useEffect } from 'react';

const InstallBanner: React.FC = () => {
    const [deferredPrompt, setDeferredPrompt] = useState<Event | null>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Controlla se l'utente ha definitivamente rifiutato o già installato
        const bannerPermanentlyDismissed = localStorage.getItem('install-banner-never-show');
        if (bannerPermanentlyDismissed === 'true') {
            return;
        }

        // Controlla l'ultimo "Non ora" e aspetta almeno 7 giorni
        const lastDismissed = localStorage.getItem('install-banner-dismissed-until');
        if (lastDismissed) {
            const dismissedDate = new Date(lastDismissed);
            const now = new Date();
            const daysDiff = (now.getTime() - dismissedDate.getTime()) / (1000 * 3600 * 24);

            if (daysDiff < 7) {
                return; // Non mostrare ancora per 7 giorni
            }
        }

        const handler = (e: Event) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setIsVisible(true);
        };

        window.addEventListener('beforeinstallprompt', handler);

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) return;

        const promptEvent = deferredPrompt as any;
        promptEvent.prompt();

        const choiceResult = await promptEvent.userChoice;
        if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
            // Utente ha installato - non mostrare mai più
            localStorage.setItem('install-banner-never-show', 'true');
            localStorage.removeItem('install-banner-dismissed-until');
        } else {
            console.log('User dismissed the A2HS prompt from native dialog');
            // Utente ha rifiutato dal dialog nativo - aspetta 30 giorni
            const futureDate = new Date();
            futureDate.setDate(futureDate.getDate() + 30);
            localStorage.setItem('install-banner-dismissed-until', futureDate.toISOString());
        }

        setDeferredPrompt(null);
        setIsVisible(false);
    };

    const handleNotNow = () => {
        // "Non ora" - riprova tra 7 giorni
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + 7);
        localStorage.setItem('install-banner-dismissed-until', futureDate.toISOString());
        setIsVisible(false);
    };

    const handleNeverShow = () => {
        // "Non interessato" - non mostrare mai più
        localStorage.setItem('install-banner-never-show', 'true');
        localStorage.removeItem('install-banner-dismissed-until');
        setIsVisible(false);
    };

    const handleDismiss = () => {
        // X in alto = comportamento come "Non ora"
        handleNotNow();
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            left: '20px',
            right: '20px',
            maxWidth: '400px',
            margin: '0 auto',
            backgroundColor: '#fff',
            padding: '16px',
            border: '1px solid #ddd',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '12px' }}>
                <p style={{ margin: '0', fontSize: '14px', lineHeight: '1.4' }}>
                    📱 Installa la nostra app per un'esperienza migliore!
                </p>
                <button
                    onClick={handleDismiss}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '18px',
                        cursor: 'pointer',
                        padding: '0',
                        marginLeft: '10px',
                        color: '#666'
                    }}
                    title="Non ora"
                >
                    ×
                </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                        onClick={handleInstallClick}
                        style={{
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            padding: '10px 16px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            flex: 1
                        }}
                    >
                        Installa ora
                    </button>
                    <button
                        onClick={handleNotNow}
                        style={{
                            backgroundColor: 'transparent',
                            color: '#666',
                            border: '1px solid #ddd',
                            padding: '10px 16px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            flex: 1
                        }}
                    >
                        Non ora
                    </button>
                </div>

                <button
                    onClick={handleNeverShow}
                    style={{
                        backgroundColor: 'transparent',
                        color: '#999',
                        border: 'none',
                        padding: '4px 8px',
                        cursor: 'pointer',
                        fontSize: '12px',
                        textDecoration: 'underline'
                    }}
                >
                    Non sono interessato
                </button>
            </div>
        </div>
    );
};

export default InstallBanner;